import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, UserPlus, Lock, X } from 'lucide-react';

interface GuestRestrictionModalProps {
    isOpen: boolean;
    onClose: () => void;
    featureName: string;
}

const GuestRestrictionModal: React.FC<GuestRestrictionModalProps> = ({ isOpen, onClose, featureName }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
            background: 'rgba(0,0,0,0.8)',
            backdropFilter: 'blur(8px)'
        }}>
            <div className="glass-card" style={{
                maxWidth: '400px',
                width: '100%',
                padding: '2.5rem',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: '1.5rem',
                border: '1px solid var(--primary-glow)'
            }}>
                <button onClick={onClose} style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', color: 'var(--text-dim)', border: 'none', cursor: 'pointer' }}>
                    <X size={20} />
                </button>

                <div style={{
                    background: 'hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.1)',
                    padding: '1.25rem',
                    borderRadius: '50%',
                    border: '1px solid var(--primary-glow)'
                }}>
                    <Lock size={32} color="var(--primary)" />
                </div>

                <div>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: '0.5rem' }}>Función Premium</h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.5 }}>
                        Para acceder a <strong>{featureName}</strong> y guardar tu progreso, necesitas crear una cuenta gratuita.
                    </p>
                </div>

                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <Link to="/register" className="btn-primary" style={{ width: '100%', height: '52px' }}>
                        <UserPlus size={18} /> REGISTRARME GRATIS
                    </Link>
                    <Link to="/login" style={{ fontSize: '0.85rem', color: 'var(--text-dim)', textDecoration: 'none', fontWeight: 700 }}>
                        Ya tengo cuenta, iniciar sesión
                    </Link>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--success)', fontSize: '0.7rem', fontWeight: 700 }}>
                    <ShieldCheck size={14} /> TUS DATOS ESTÁN PROTEGIDOS
                </div>
            </div>
        </div>
    );
};

export default GuestRestrictionModal;
